// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__yGatx","inputWrap":"CustomTip_inputWrap__WneCQ"};